export function initNav(): void {
  const navToggle = document.querySelector<HTMLButtonElement>('.fc-header__btn-toggle');
  const menu = document.querySelector<HTMLElement>('.fc-header__container-inner');

  if (navToggle && menu) {
    const labelOpen = navToggle.dataset.labelOpen ?? 'Otwórz nawigację';
    const labelClose = navToggle.dataset.labelClose ?? 'Zamknij nawigację';

    navToggle.addEventListener('click', () => {
      const isOpen = navToggle.classList.toggle('fc-header__btn-toggle--active');
      menu.classList.toggle('fc-header__container-inner--is-open', isOpen);

      navToggle.setAttribute('aria-label', isOpen ? labelClose : labelOpen);
      navToggle.setAttribute('aria-expanded', String(isOpen));
    });
  }

  document.addEventListener('keydown', (event: KeyboardEvent) => {
    if (event.key !== 'Escape') return;

    if (navToggle?.classList.contains('fc-header__btn-toggle--active')) {
      const labelOpen = navToggle.dataset.labelOpen ?? 'Otwórz nawigację';

      navToggle.classList.remove('fc-header__btn-toggle--active');
      menu?.classList.remove('fc-header__container-inner--is-open');

      navToggle.setAttribute('aria-label', labelOpen);
      navToggle.setAttribute('aria-expanded', 'false');
    }
  });
}
